// extracted by mini-css-extract-plugin
module.exports =  {"select":"XWkf5qoXKlASz11JxLn6"};